import { API, API_GET_ID } from "../../Config";

export const GetSingleOrder = (id) => {
  return API_GET_ID(API.GetOrderById, id);
};
